import React from 'react';
import { LoaderWrapper, Loader } from './StyledComponents';

export const GlobalLoader = ({ cleanBackground }) => (
  <LoaderWrapper cleanBackground={cleanBackground}>
    <Loader>
      <div />
      <div />
      <div />
      <div />
    </Loader>
  </LoaderWrapper>
);

export const LoaderComponent = () => <Loader />;

export default GlobalLoader;
